import { AriaLive } from "../../services/aria.live.service";

/** Runs AngJS `onClosed` / availability refresh inside a digest when the bridge is present. */
export function runInAngJsTimeout(callback: () => void): void {
    if (window.angBridge?.$timeout) {
        window.angBridge.$timeout(callback);
    } else {
        callback();
    }
}

/** Dismiss the modal immediately, then announce on the global live region (no visible delay). */
export function closeModalThenAnnounce(announcement: string | undefined, finishClose: () => void): void {
    runInAngJsTimeout(() => {
        finishClose();
        if (announcement) {
            void AriaLive.announce(announcement);
        }
    });
}
